import React from "react";

/** Decorative molecular-network SVG used behind the hero. */
export const MolecularBackground = () => {
  const nodes = [
    { cx: 120, cy: 140, r: 7 },
    { cx: 300, cy: 80, r: 5 },
    { cx: 520, cy: 180, r: 9 },
    { cx: 760, cy: 100, r: 6 },
    { cx: 980, cy: 220, r: 8 },
    { cx: 1180, cy: 130, r: 5 },
    { cx: 1360, cy: 260, r: 7 },
    { cx: 220, cy: 360, r: 6 },
    { cx: 460, cy: 420, r: 9 },
    { cx: 700, cy: 360, r: 5 },
    { cx: 880, cy: 460, r: 7 },
    { cx: 1100, cy: 380, r: 6 },
    { cx: 1300, cy: 500, r: 8 },
    { cx: 180, cy: 600, r: 5 },
    { cx: 420, cy: 660, r: 7 },
    { cx: 640, cy: 580, r: 6 },
    { cx: 860, cy: 700, r: 8 },
    { cx: 1080, cy: 620, r: 5 },
    { cx: 1280, cy: 720, r: 7 },
  ];

  // build edges between nearby nodes
  const edges = [];
  for (let i = 0; i < nodes.length; i++) {
    for (let j = i + 1; j < nodes.length; j++) {
      const dx = nodes[i].cx - nodes[j].cx;
      const dy = nodes[i].cy - nodes[j].cy;
      const d = Math.sqrt(dx * dx + dy * dy);
      if (d < 300) edges.push([i, j, d]);
    }
  }

  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 overflow-hidden pointer-events-none"
      data-testid="molecular-bg"
    >
      <svg
        viewBox="0 0 1440 800"
        preserveAspectRatio="xMidYMid slice"
        className="absolute inset-0 h-full w-full opacity-[0.7]"
      >
        <defs>
          <radialGradient id="node-grad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#e8c25f" stopOpacity="1" />
            <stop offset="100%" stopColor="#a88a28" stopOpacity="0.5" />
          </radialGradient>
          <linearGradient id="line-grad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#c8a951" stopOpacity="0.05" />
            <stop offset="50%" stopColor="#c8a951" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#c8a951" stopOpacity="0.05" />
          </linearGradient>
        </defs>

        {edges.map(([a, b, d], idx) => (
          <line
            key={idx}
            x1={nodes[a].cx}
            y1={nodes[a].cy}
            x2={nodes[b].cx}
            y2={nodes[b].cy}
            stroke="url(#line-grad)"
            strokeWidth={1 - d / 600}
          />
        ))}

        {nodes.map((n, i) => (
          <g key={i} className="node-pulse" style={{ animationDelay: `${(i % 7) * 0.3}s`, transformOrigin: `${n.cx}px ${n.cy}px` }}>
            <circle cx={n.cx} cy={n.cy} r={n.r + 4} fill="url(#node-grad)" opacity="0.35" />
            <circle cx={n.cx} cy={n.cy} r={n.r} fill="url(#node-grad)" />
            <circle cx={n.cx} cy={n.cy} r={n.r - 2} fill="#fff" opacity="0.85" />
          </g>
        ))}
      </svg>

      {/* warm radial wash on top */}
      <div className="absolute inset-0 hero-ring" />
    </div>
  );
};
